const statusesWithdraw = [
  {name: 'initiated', color: '5B47FF'},
  {name: 'cancelled', color: '2'},
  {name: 'sent', color: '2CE889'}
];

const statusesTrx = [
  {name: 'created', color: 'FFBF43'},
  {name: 'confirmed', color: 'FFBF43'},
  {name: 'completed', color: '2CE889'},
  {name: 'requested', color: '9C8FFF'},
  {name: 'expired', color: '717275'},
  {name: 'cancelled', color: 'EE4F4F'},
  {name: 'failed', color: 'EE4F4F'}
]

module.exports = {
  statusesTrx,
  statusesWithdraw: 'c5B47FF.initiated c2.cancelled c2CE889.sent'
};
